import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription, timer } from 'rxjs';
import { ConfirmationDialogOptions } from './confirmation-dialog';


@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
})
export class ConfirmationDialogComponent implements OnInit {
    TitleText?: string;
    MessageText?: string;
    SubMessageText?: string;
    IconColor?: string;
    IconName?: string;
    OKText?: string;
    CancelText?: string;
    ShowIcon?: boolean;
    DelayDelete?: number | null = 0;
    DisableDelete?: boolean;

    countDown?: Subscription | null;
    counter = 5;
    tick = 1000; // seconds

    constructor(
        private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogOptions
    ) {
        const self = this;
        self.TitleText = data.TitleText || 'Confirmation Requested...';
        self.MessageText = data.MessageText || '';
        self.SubMessageText = data.SubMessageText || '';
        self.IconColor = data.IconColor || 'primary';
        self.IconName = data.IconName || 'help';
        self.OKText = data.OKText || 'OK';
        self.CancelText = data.CancelText || 'Cancel';
        self.ShowIcon = data.ShowIcon != null ? data.ShowIcon : true;
        self.DelayDelete = data.DelayDelete ? data.DelayDelete * 1000 : null;
        self.DisableDelete = data.DelayDelete ? true : false;
    }

    ngOnInit(): void {
        const self = this;
        // If a delay is specified, the Delete button will be disabled until the timer has elapsed.
        // This is to prevent accidental double-click for specific delete actions.
        if (self.DelayDelete) {
            self.countDown = timer(0, self.tick).subscribe(() => 
            {
                if (self.data.DelayDelete) --self.data.DelayDelete;
                self.data.DelayDelete === 0 ? self.DisableDelete = false : null;
            });
            // setTimeout((_) => (self.disableDelete = false), self.delayDelete);
        }
    }

    ngOnDestroy(){
        this.countDown = null;
    }

    CancelHandler(): void {
        this.dialogRef.close(null);
    }

    OKHandler(): void {
        this.dialogRef.close(true);
    }
}
